import type { ResponsivePie } from "@nivo/pie";

export const nivo_theme = {
  axis: {
    ticks: {
      text: {
        fill: "var(--foreground)",
      },
    },
    legend: {
      text: {
        fill: "var(--foreground)",
      },
    },
  },
  legends: {
    text: {
      fill: "var(--foreground)",
      fontFamily: "Figtree",
    },
  },
  labels: {
    text: {
      fontFamily: "Figtree",
    },
  },
  tooltip: {
    container: {
      background: "var(--card)",
      color: "var(--foreground)",
      borderRadius: "8px",
    },
  },
  crosshair: {
    line: {
      stroke: "var(--foreground)",
    },
  },
} satisfies React.ComponentProps<typeof ResponsivePie>["theme"];
